import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';
import { ModalButtonCancel } from '../../constant';

export const FormMicContainer = (props) => {

    const {
        toggle, loading, handleInputChange, methodAction, name_container, button,
    } = props;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre del contenedor <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="name_container"
                            value={name_container}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
            <ModalFooter>
                <Button size="sm" outline color="primary" type="submit" className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {button}
                </Button>
                <Button size="sm" outline color='danger' type="button" onClick={toggle}>{ModalButtonCancel}</Button>
            </ModalFooter>
        </Form>
    )
}
